import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CountryMapper } from "../../utils/mappers/country/country.mapper";
import { COUNTRY_ENDPOINTS } from "../../components/mediaManager/admon/country/country-endpoints";
import { Country } from "../../utils/types/country/country.type";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class CountryService extends BaseApiService<Country> {
    model = Country;
    mapper = new CountryMapper();
    apiEndPoint: any = COUNTRY_ENDPOINTS;

    create(data: Country): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.list, data).pipe(
            map((res) => {
                return res;
            })
        );
    }
    getList(filter?: FilterType): Observable<PagedApiResponse<Country>> {
        let params = new HttpParams();
        params = params.append("limit", filter.limit);
        params = params.append("offset", filter.offset);

        return this.http.get(this.apiEndPoint.list, { params }).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    getListWithNoPaging(): Observable<PagedApiResponse<Country>> {
        return this.http.get(this.apiEndPoint.list).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    update(data: Country): Observable<boolean> {
        const { id } = data;
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    delete(id: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
